import { isUndefined, isFinite, isString, get } from 'lodash-es'

function zeroPad(rawNum, width) {
  const num = `${rawNum}`
  return num.length > width
    ? num
    : new Array(width - num.length + 1).join('0') + num
}

function formatPct(f) {
  const num = Math.floor(100 * f)
  return `${num}%`
}

const formatTime = (sec) => {
  // TODO (noahlaux): We would like to transition to Number.isNaN, but we have too much view logic
  // depending on how the window.isNaN implementation works
  // eslint-disable-next-line no-restricted-properties
  if (window.isNaN(sec) || sec < 0) {
    return ''
  }
  const time = Math.round(sec)
  const days = Math.floor(time / (3600 * 24))
  const hours = Math.floor((time % (3600 * 24)) / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const seconds = Math.floor(time % 60)

  if (days) {
    const hoursFmt = hours === 0 ? '' : ` ${hours}h`
    return `${days}d${hoursFmt}`
  }

  if (hours) {
    const minutesFmt = minutes === 0 ? '' : ` ${minutes}m`
    return `${hours}h${minutesFmt}`
  }

  if (minutes) {
    const secondsFmt = seconds === 0 ? '' : ` ${seconds}s`
    return `${minutes}m${secondsFmt}`
  }

  return `${seconds}s`
}

function formatDate(rawMs) {
  const ms = parseInt(rawMs, 10)
  if (Number.isNaN(ms) || ms < 0) {
    return 'Invalid Date'
  }

  const d = new Date(ms)

  const v = [
    d.getFullYear(),
    zeroPad(d.getMonth() + 1, 2),
    zeroPad(d.getDate(), 2),
  ]

  return v.join('-')
}

const intToBool = (val) => !!val

const formatBytes = (bytesData, decimals) => {
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const bytes = parseInt(bytesData, 10)

  if (bytes === 0) {
    return '0 Bytes'
  }

  const dm = isUndefined(decimals) ? 2 : decimals
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const exp = k ** i
  const num = parseFloat((bytes / exp).toFixed(dm))

  return `${num} ${sizes[i]}`
}

const formatNum = (val) => {
  if (isUndefined(val)) {
    return val
  }

  // format thousand separators to be dots
  return val.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, '.')
}

const ordinalNumMap = { 1: 'st', 2: 'nd', 3: 'rd' }

const formatOrdinalNum = (num = '') => {
  if (!(isFinite(num) || isString(num))) {
    return ''
  }

  const numString = num.toString()
  if (/(11|12|13)$/.test(numString)) {
    return `${num}th`
  }

  const lastDigit = numString.slice(-1)
  return `${num}${get(ordinalNumMap, lastDigit, 'th')}`
}

const formatBitrate = (size) => {
  let i = -1
  let fileSizeInBytes = size
  const byteUnits = [
    ' kbps',
    ' Mbps',
    ' Gbps',
    ' Tbps',
    'Pbps',
    'Ebps',
    'Zbps',
    'Ybps',
  ]

  do {
    fileSizeInBytes /= 1024
    i += 1
  } while (fileSizeInBytes > 1024)

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i]
}

/** *
 * Returns bitrate in Megabit per second
 * @param bps Bits per second
 * @returns {number}
 */
const getBitrate = (bps) => bps * 1e-6

/**
 * @param  {number} price
 * @param  {string} currency
 * @param  {string|undefined} [locale=en-US]
 * @returns {string}
 */
const formatPrice = (price, currency, locale) => {
  // Ensure we have the locale in the correct format
  // @see https://en.wikipedia.org/wiki/IETF_language_tag
  // TODO (casperstorm): Server sends `en_US`
  const formattedLocale = locale?.replace(/_/g, '-') ?? 'en-US'

  // Create the formatter
  const formatter = new Intl.NumberFormat(formattedLocale, {
    style: 'currency',
    currency,
  })

  // Returns the formatted price
  return formatter.format(price)
}

export {
  formatTime,
  formatDate,
  formatOrdinalNum,
  zeroPad,
  formatPct,
  formatBytes,
  intToBool,
  formatNum,
  formatBitrate,
  getBitrate,
  formatPrice,
}
